import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'formly-wrapper-clean',
  template: `<ng-container #fieldComponent></ng-container>`,
})
export class WrapperCleanComponent extends FieldWrapper {}
